var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "24px",
    viewBox: "0 0 30 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Load_Node") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grid-Editor_st2",
    transform: "translate(-1070.000000, -676.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(447.000000, 229.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Battery_1767544",
    transform: "translate(623.000000, 447.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8796,0.2244 L0.2499,0.2244 L0.2499,23.9982 L15.8793,23.9982 L15.8793,0.2244 L15.8796,0.2244 Z M7.05185151,20.2244 L8.06024891,12.361085 L5.2499,12.361085 L5.29005376,3.2244 L9.51116552,3.2244 L8.28668297,8.95809992 L12.2499,8.95809992 L7.05185151,20.2244 Z M29.1462,4.0629 C29.637,4.524 29.8833,5.1819 29.8791,6.0183 C29.8659,8.5221 27.2976,8.5713 25.5981,8.604 C23.472,8.6448 22.8279,8.8206 22.71,9.5268 L24.1935,9.5268 C25.2528,9.5268 25.4937,10.5456 25.4937,11.6043 L25.4937,14.5257 L24.2688,14.5257 L24.2688,16.9227 C24.2688,17.2272 24.0225,17.4741 23.718,17.4741 C23.4135,17.4741 23.1669,17.2272 23.1669,16.9227 L23.1669,14.5257 L20.5323,14.5257 L20.5323,16.9227 C20.5323,17.2272 20.2857,17.4741 19.9812,17.4741 C19.677,17.4741 19.4307,17.2272 19.4307,16.9227 L19.4307,14.5257 L18.1524,14.5257 L18.1524,11.6043 C18.1524,10.5456 18.3933,9.5268 19.4526,9.5268 L20.9058,9.5268 C21.0933,6.8982 23.7675,6.8388 25.5636,6.8043 C27.7287,6.7629 28.0761,6.5787 28.0791,6.0087 C28.0803,5.7912 28.0524,5.5047 27.9138,5.3742 C27.6084,5.0874 26.622,5.1537 25.9017,5.2023 C25.6671,5.2179 25.4361,5.2335 25.2153,5.2416 C23.5668,5.3019 21.9939,5.3004 20.3316,5.2992 C19.7895,5.3031 19.1163,5.307 18.4452,5.3148 C17.778,5.3229 17.1069,5.331 16.5396,5.331 L16.5396,3.531 C17.1003,3.531 17.7639,3.5229 18.4233,3.5151 C19.1025,3.507 19.7688,3.4992 20.3331,3.4995 C21.9798,3.5013 23.5347,3.5022 25.149,3.4431 C25.3521,3.4356 25.5648,3.4209 25.7805,3.4065 C26.9469,3.3282 28.2693,3.2391 29.1462,4.0629 Z",
    id: "Load_Node"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadNode);
export default __webpack_public_path__ + "static/media/Load_Node.80f332a50befd6e544984265384b53d2.svg";
export { ForwardRef as ReactComponent };